





































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    customInputClass: {
      type: String,
      default: '',
    }
  }
})
export default class InputV2 extends Vue {
}
